export default {
  'business-deal-handshake-circle': require('./business-deal-handshake-circle.svg'),
  'button-play': require('./button-play.svg'),
  'chevron-left': require('./chevron-left.svg'),
  'chevron-right': require('./chevron-right.svg'),
  close: require('./close.svg'),
  'rating-star-circle': require('./rating-star-circle.svg'),
  'social-instagram': require('./social-instagram.svg'),
  'social-media-facebook': require('./social-media-facebook.svg'),
  'social-video-youtube': require('./social-video-youtube.svg'),
  'video-player-movie': require('./video-player-movie.svg'),
  'vip-royal': require('./vip-royal.svg'),
};
